import React, { useCallback } from "react";
import { api } from "@/lib/api";
import { cacheGet, cacheKey, fetchCached } from "@/lib/dataCache";

const OfferBanner = () => {
  const [offer, setOffer] = React.useState(() => cacheGet(cacheKey(["offers", "active"])));

  const loadOffer = useCallback(
    () => api.get("/offers/active").then((res) => res.data),
    []
  );

  React.useEffect(() => {
    const key = cacheKey(["offers", "active"]);
    fetchCached(key, loadOffer, {
      onUpdate: (data) => setOffer(data),
    })
      .then((data) => setOffer(data))
      .catch(() => setOffer(null));
  }, [loadOffer]);

  if (!offer?.enabled || !offer.code) return null;

  return (
    <div
      className="border-b border-border bg-[#f3f3f3] py-2.5 text-center text-[13px] sm:text-sm text-[#2b2b2b]"
      data-testid="offer-banner"
    >
      <p className="px-4 leading-relaxed">
        <span className="font-semibold">{offer.headline}</span>
        {" "}
        <span className="text-[#555]">|</span>
        {" "}
        <span className="font-semibold">USE: {offer.code}</span>
      </p>
    </div>
  );
};

export default OfferBanner;
